/** @format */

import { reduceLocales } from '@/i18n/utils/reduce-locales';
import { ALL_LOCALES, SITE_URL } from '@/utils/gatsby/constants';
import { TLocale } from '@/utils/gatsby/types';
import React from 'react';
import { TOtherPaths } from '../../@ducks/general/declarations';

const X_DEFAULT = 'x-default';
const X_DEFAULT_LANG = 'en';

export const utilityGenerateAlternateLinks = (
  otherPaths: TOtherPaths,
  originalPath?: string,
  roomCode?: string,
  options?: {
    localesEnabled?: TLocale[];
    localesDisabled?: TLocale[];
  },
) => {
  const editOriginalPath = !!originalPath ? originalPath.substring(1) : '';

  const generateNewPaths = () => {
    let addPaths = reduceLocales(() => editOriginalPath, { allLocales: true });
    return { ...addPaths, ...otherPaths, [X_DEFAULT]: otherPaths?.[X_DEFAULT_LANG] ?? editOriginalPath };
  };

  const newOtherPaths: { [lang: string]: string } = generateNewPaths();

  const linkTags = [];

  const optionLocalesEnabled = options?.localesEnabled
    ? [
        ...(options.localesEnabled ?? []),
        // If localesEnabled include X_DEFAULT_LANG, add the alternate x-default
        ...(options.localesEnabled?.includes(X_DEFAULT_LANG) ? [X_DEFAULT] : []),
      ]
    : undefined;

  for (const lang in newOtherPaths) {
    let completeLink;

    if (options?.localesDisabled && options?.localesDisabled?.includes(lang as TLocale)) continue;
    if (optionLocalesEnabled && !optionLocalesEnabled.includes(lang as TLocale)) continue;

    if (ALL_LOCALES.includes(lang as TLocale) || lang === X_DEFAULT) {
      const langPath = lang === X_DEFAULT ? X_DEFAULT_LANG : lang;

      if (newOtherPaths[lang][0] === '/') {
        newOtherPaths[lang] = newOtherPaths[lang].substring(1);
      }

      completeLink = `${SITE_URL}/${langPath}/${newOtherPaths[lang]}`;

      if (roomCode) {
        completeLink += `?roomCode=${roomCode}`;
      }
    } else {
      completeLink = newOtherPaths[lang];
    }

    const linkTag = <link key={lang} rel="alternate" hrefLang={lang} href={completeLink} />;
    linkTags.push(linkTag);
  }

  return linkTags;
};
